module.exports = __webpack_public_path__ + "img/alerts-5.0a3b537c.gif";